'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Provider = require('../Provider');

var _Provider2 = _interopRequireDefault(_Provider);

var _Tag = require('../Tag');

var _ResolveValue = require('../ResolveValue');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Provider2.default({
  isTag: function isTag(arg) {
    if (!(arg instanceof _Tag.Tag)) {
      return false;
    }

    for (var _len = arguments.length, types = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      types[_key - 1] = arguments[_key];
    }

    if (types.length) {
      return types.reduce(function (isType, type) {
        return isType || type === arg.type;
      }, false);
    }

    return true;
  },
  isResolveValue: function isResolveValue(arg) {
    return arg instanceof _ResolveValue.ResolveValue;
  },
  value: function value(arg) {
    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (arg instanceof _ResolveValue.ResolveValue) {
      return arg.getValue(overrides ? Object.assign({}, this.context, overrides) : this.context);
    }

    return arg;
  },
  path: function path(arg) {
    if (arg instanceof _Tag.Tag) {
      return arg.getPath(this.context);
    }

    throw new Error('You are extracting a path from an argument that is not a Tag.');
  }
}, {
  wrap: false
});
//# sourceMappingURL=Resolve.js.map


//////////////////
// WEBPACK FOOTER
// ./~/function-tree/lib/providers/Resolve.js
// module id = 237
// module chunks = 0